import { Link as RouterLink } from 'react-router-dom'
import { Trans } from '@lingui/macro'

import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

export default function AccessibilityPage() {
  return (
    <Box sx={{ p: 4, maxWidth: 700 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        <Trans>Accessibility</Trans>
      </Typography>

      <Typography sx={{ mb: 3 }}>
        <Trans>Promotal is committed to making MedConnect Professional accessible to all users.</Trans>
      </Typography>

      <Box sx={{ bgcolor: '#e3f2fd', border: '1px solid #90caf9', borderRadius: 2, p: 3, mb: 4 }}>
        <Typography variant="h6">
          <Trans>RGAA compliance rate</Trans>:{' '}
          <Box component="span" sx={{ color: '#1565c0', fontWeight: 'bold' }}>83 %</Box>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <Trans>Standard</Trans>: RGAA 4.0
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <Trans>Evaluation date</Trans>: 2026-03-27
        </Typography>
      </Box>

      <Typography variant="h6" gutterBottom>
        <Trans>Conformity status</Trans>
      </Typography>
      <Typography sx={{ mb: 3 }}>
        <Trans>MedConnect Professional is partially compliant with RGAA 4.0. Remaining non-conformities are listed in the full accessibility declaration.</Trans>
      </Typography>

      <Typography variant="h6" gutterBottom>
        <Trans>Contact</Trans>
      </Typography>
      <Typography sx={{ mb: 1 }}>
        <Trans>If you encounter an accessibility issue, please contact us:</Trans>
      </Typography>
      <Typography>
        <Link href="mailto:info@promotal-medconnect.com">info@promotal-medconnect.com</Link>
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Link component={RouterLink} to="/" underline="hover">
          <Trans>Back to home</Trans>
        </Link>
      </Box>
    </Box>
  )
}
